// akhila 1/12/2022 3031450488 added workqueue search
import React, {useEffect, useState} from 'react';
import RuleGroupSearch from './ReportMasterSearch';
import {ResetStatus as resetStatus} from '../../../../redux/reducers/BRE/AddRuleGroup';
import {useDispatch} from 'react-redux';
import WorkQueueSearch from './../../../Dashboard/WorkQueueMaintenance/WorkQueueSearch';

const SearchReportMasterContainer = ({
  setTabValue,
  setBreCode,
  setCopy,
  copy,
  setReportCode,
  openTemplate,
  setOpenTemplate,
  workQueue,
  setWorkQueue,
  setEditExisting,
}) => {
  const dispatch = useDispatch();

  const [selectedRows, setSelectedRows] = useState([]);
  const [searchData, setSearchData] = useState({});
  useEffect(() => {
    dispatch(resetStatus());
  }, []);

  return (
    <>
      {workQueue ? (
        <WorkQueueSearch
          setTabValue={setTabValue}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          searchData={searchData}
          setSearchData={setSearchData}
          setBreCode={setBreCode}
          openTemplate={openTemplate}
          setOpenTemplate={setOpenTemplate}
          setCopy={setCopy}
          copy={copy}
          workQueue={workQueue}
          setWorkQueue={setWorkQueue}
          setEditExisting={setEditExisting}
        />
      ) : (
        <RuleGroupSearch
          setTabValue={setTabValue}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          searchData={searchData}
          setSearchData={setSearchData}
          setBreCode={setBreCode}
          openTemplate={openTemplate}
          setOpenTemplate={setOpenTemplate}
          setCopy={setCopy}
          copy={copy}
          workQueue={workQueue}
          setWorkQueue={setWorkQueue}
          setEditExisting={setEditExisting}
        />
      )}
    </>
  );
};
export default SearchReportMasterContainer;
